var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpresas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 25.6666V4.66665C7.00004 4.04781 7.24587 3.45432 7.68346 3.01673C8.12104 2.57915 8.71454 2.33331 9.33337 2.33331H18.6667C19.2855 2.33331 19.879 2.57915 20.3166 3.01673C20.7542 3.45432 21 4.04781 21 4.66665V25.6666M7.00004 25.6666H21M7.00004 25.6666H4.66671C4.04787 25.6666 3.45438 25.4208 3.01679 24.9832C2.57921 24.5456 2.33337 23.9522 2.33337 23.3333V16.3333C2.33337 15.7145 2.57921 15.121 3.01679 14.6834C3.45438 14.2458 4.04787 14 4.66671 14H7.00004M21 25.6666H23.3334C23.9522 25.6666 24.5457 25.4208 24.9833 24.9832C25.4209 24.5456 25.6667 23.9522 25.6667 23.3333V12.8333C25.6667 12.2145 25.4209 11.621 24.9833 11.1834C24.5457 10.7458 23.9522 10.5 23.3334 10.5H21M11.6667 6.99998H16.3334M11.6667 11.6666H16.3334M11.6667 16.3333H16.3334M11.6667 21H16.3334",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresas);
export default __webpack_public_path__ + "static/media/empresas.09b1f7a5f375a314c97b76e70e80e0fa.svg";
export { ForwardRef as ReactComponent };